import { CODE_2FA_MIN_LENGTH, PASSWORD_MIN_CHAR } from ".";

export const EMAIL_REQUIRED = "Email address is a required field";
export const INVALID_EMAIL = "Invalid email address";
export const REQUIRED = "Required";
export const PASSWORD_VALIDATION = `Password must be at least ${PASSWORD_MIN_CHAR} characters with special, uppercase, lowercase, and numeric characters.`;
export const PASSWORD_REQUIRED = "Password is a required field";
export const PASSWORD_MUST_MATCH = "Confirm Password must match with the password";
export const PASSWORD_STRENGTH = "Password doesn't match the requirement.";
export const MIN_CHAR_LENGTH = `Please enter min ${PASSWORD_MIN_CHAR} char`;
export const NEW_PASSWORD_SHOULD_DIFF = "New password should not match the current password";
export const CODE_REQUIRED_2FA = "MFA code is required";
export const ROLE_IS_REQUIRED = "Role is a required field";

export const FULLNAME_REQUIRED = "Full name is a required field";
export const FULLNAME_MIN_CHAR = 2;
export const FULLNAME_MIN_CHAR_MESSAGE = `Full name must be at least ${FULLNAME_MIN_CHAR} characters long`;
export const FULLNAME_MAX_CHAR = 30;
export const FULLNAME_MAX_CHAR_MESSAGE = `Full name cannot be more than ${FULLNAME_MAX_CHAR} characters.`;
export const INVALID_PHONE = "This is not a valid number.";
export const PHONE_REQUIRED = "Phone number is a required field";
export const COMPANY_NAME_REQUIRED = "Company name is a required field";
export const COMPANY_NAME_MIN_CHAR = 2;
export const COMPANY_NAME_MIN_CHAR_MESSAGE = `Company name must be at least ${COMPANY_NAME_MIN_CHAR} characters long`;
export const COMPANY_NAME_MAX_CHAR = 100;
export const COMPANY_NAME_MAX_CHAR_MESSAGE = `Company name cannot be more than ${COMPANY_NAME_MAX_CHAR} characters`;
export const COMPANY_WEBSITE_REQUIRED = "Company website is a required field";
export const COMPANY_WEBSITE_VALID = "Please enter a valid URL";
export const INVALID_URL = "Please enter a valid URL";
export const URL_REQUIRED = "URL is a required field";
export const ONE_URL_REQUIRED = "At least one URL is required";
export const WEB_APP_URL_REQUIRED = "Web App URLs are required";


export const FIRST_NAME_REQUIRED = "First name is a required field";
export const LAST_NAME_REQUIRED = "Last name is a required field";

export const CONFIRM_PASSWORD_REQUIRED = "Confirm password is a required field";

export const CODE_2FA_MIN_LENGTH_MSG = `Please enter exact ${CODE_2FA_MIN_LENGTH} digits`;

export const CODE_2FA_DIGIT_ONLY_MSG = `Code must be digits only`;

export const IMAGE_FILE_TYPES = "Please select a valid image (png, jpg, or jpeg).";
export const IMAGE_FILE_SIZE_LIMIT = "Image size exceeds 1MB limit.";

export const ADDRESS_REQUIRED = "Address is a required field";
export const MOBILE_NUMBER_REQUIRED = "Mobile Number is a required field";
export const MOBILE_NUMBER_INVALID = "Mobile Number is not a valid number";
export const ROLE_NAME_LABEL = "Role Name";
export const PROJECT_LABEL = "Project";
export const SITE_NAME_LABEL = "Site Name";
export const SITE_DESCRIPTION_LABEL = "Site Description";
export const SPIDER_TYPE_LABEL = "Spider Type";
export const MAX_DURATION_OF_SPIDER = "Max Duration of Spider";
export const SCAN_STRENGTH_LABEL = "Scan Strength";
export const SQL_INJECTION_STRENGTH_LABEL = "SQL Injection Strength";
export const NOSQL_INJECTION_STRENGTH_LABEL = "NoSQL Injection Strength";
export const LLM_REDTEAM_ENDPOINT_LABEL = "AI Feature Endpoint URL";
export const LLM_REDTEAM_INPUT_FIELD_LABEL = "Input Field Name";
export const USER_AGENT_TYPE_LABEL = "User Agent Type";
export const IMPORT_TYPE_LABEL = "Import Type";
export const FILE_IMPORT_REQUIRED = "File Import is a required field";
export const OVERRIDE_SERVER_URL = "Override Server URL";
export const AUTHENTICATION_TYPE_LABEL = "Authentication Type";
export const LOGIN_URL_LABEL = "Login URL";
export const POST_ATTRIBUTE_FOR_USERNAME = "POST attribute for Username";
export const POST_ATTRIBUTE_FOR_PASSWORD = "POST attribute for Password";
export const USERNAME_LABEL = "Username";
export const PASSWORD_LABEL = "Password";
export const ROLE_LABEL = "Role";
export const SHARED_SECRET_KEY = "Shared Secret Key";
export const COOKIE_NAME_LABEL = 'Cookie Name';
export const VALUE_LABEL = 'Value';
export const HEADER_NAME_LABEL = 'Header Name';
export const PROJECT_NAME_LABEL = "Project Name";
export const FULLNAME_LABEL = "Full Name";
export const NOTE_LABEL = "Note";
export const REQUEST_URL_LABEL = "URL is a required field";
export const SCAN_REGION = "Scan Region";
export const UPLOAD_URL_REQUIRED = "Upload Url is required field";
export const UPLOAD_FILE_TYPE_REQUIRED = "Upload File Type is a required field";
export const UPLOAD_INSTRUCTION_REQUIRED = "Upload Task Instructions is a required field";
export const LOGIN_INSTRUCTION = "Login Instructions";

// Request LOA Messages
export const SITE_NAME_REQUIRED = "Site name is a required field";
export const SCAN_ID_LABEL = "Scan ID";
export const REQUEST_LOA_SITE_NAME_LABEL = "Site Name";
export const REQUEST_LOA_EMAIL_LABEL = "Email";
export const REQUEST_LOA_PHONE_LABEL = "Phone Number";
export const PROJECT_NAME_REQUIRED = "Project is a required field";
export const REQUEST_LOA_PROJECT_LABEL = "Project";